<template>
  <el-dialog :title="(isEdit?'编辑':'新增')+'标签'" :visible.sync="show" lock-scroll :before-close="close" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="formData" label-width="120px" size="small">
      <el-form-item label="标签名称">
          <el-input 
            @keyup.enter.native="doSubmit"
            v-model="formData.tagName" 
            autocomplete="off" 
            style="width:140px"
            :readonly="isTagNameLoading"
          ></el-input>
      </el-form-item>

      <el-form-item label="自动发布时段">
        <el-time-select
          placeholder="起始时间"
          style="width:120px;"
          v-model="formData.extension.se.payload.startAt"
          :picker-options="{
            start: '00:00',
            step: '00:05',
            end: '23:59'
          }">
        </el-time-select>
         - 
        <el-time-select
          placeholder="结束时间"
          style="width:120px;"
          v-model="formData.extension.se.payload.endAt"
          :picker-options="{
            start: '00:00',
            step: '00:05',
            end: '23:59',
            minTime: formData.extension.se.payload.startAt
          }">
        </el-time-select>
      </el-form-item>

    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="doSubmit" :loading="isTagNameLoading">保 存</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'TagForm',
  props: {
    data: Object,
    isEdit: Boolean,
    show: Boolean,
  },
  data(){
    return {
      formData:{
        extension:{
          se:{
            payload:{startAt:"",endAt:""}
          }
        }
      },
      isTagNameLoading:false,
    }
  },
  watch: {
    data(newData){
      var data = this.$root.copy({
        tagName:"",
        ...newData
      });
      if(!data.extension){
        data.extension = {};
      }
      if(!data.extension.se){
        data.extension.se = {
          payload:{startAt:"",endAt:""}
        }
      }
      if(!data.extension.se.payload){
        data.extension.se.payload = {startAt:"",endAt:""};
      }
      

      this.formData = data;
    }
  },
  
  methods:{
    
    close(){
      this.$emit('update:show',false);
    },

    async checkHasTagName(tagName){
      return await this.request.get(`/api/v1/tags?page=1&size=20&tagName=${tagName}`).then( async res=>{
        if(!res || !res.total){return false;}
        if(res.results && res.results.length){
          console.log(res.results);
          var target = res.results.find(t=>t.tagName == tagName);
          if(target && target.tagId){
            return target;
          } else {
            return false;
          }
        }
      });
    },

    async doAddUserTag(tagId){
      this.isTagNameLoading = true;
      return await this.request.post(`/api/v1/collects/users/${this.formData.userId}/tag`,{tagId}).then(res=>{
        this.isTagNameLoading = false; 
        this.$message.success("标签添加成功");
        return res;
      });
    },
    async doCreateTag(tagName){
      this.isTagNameLoading = true;
      return await this.request.post(`/api/v1/tags`,{tagName,extension:this.formData.extension}).then(async res=>{
        this.isTagNameLoading = false;
        return res;
      })
    },
    async doUpdateTag(tag){
      this.isTagNameLoading = true;
      return await this.request.put(`/api/v1/tags/${tag.tagId}?tagName=${tag.tagName}`,{tagName:tag.tagName,extension:this.formData.extension}).then(async res=>{
        this.isTagNameLoading = false;
        return res;
      })
    },
    async doSubmit(){
      var tagName = this.formData.tagName.replace(/(^\s*)|(\s*$)/g, "");

      if(!tagName){
        this.$message.warning("标签不能为空");
        return ;
      }

      var hasTag = await this.checkHasTagName(tagName);
      
      
      if(this.isEdit){
        if(this.data.tagName != this.formData.tagName && hasTag){
          this.$message.warning("标签名字已存在");
          return ;
        }
        await this.doUpdateTag({
          tagId:this.data.tagId,
          tagName
        });
      } else {
        
        if(hasTag){
          this.$message.warning("标签已存在");
          return ;
        }
        await this.doCreateTag(tagName);
      }
      
      this.close();
      
      
    },
  },
}
</script>

<style scoped>

</style>
